import { SvgIconProps } from "@mui/material";

export const CalendarIcon = (props: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <rect x="4" y="4" width="16" height="17" rx="2" />
    <path d="M8 2v4M16 2v4M4 10h16" />
  </svg>
);
